import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import type { VendorPaymentVendorDto } from "@/lib/benefit-types"

export function VendorPaymentFields({
  idPrefix = "vendor-payment",
  vendorId,
  vendors,
  vendorDisabled,
  accountNumber,
  paymentAmount,
  disabled,
  onVendorChange,
  onAccountNumberChange,
  onPaymentAmountChange,
}: {
  idPrefix?: string
  vendorId: string
  vendors: readonly VendorPaymentVendorDto[]
  vendorDisabled: boolean
  accountNumber: string
  paymentAmount: string
  disabled: boolean
  onVendorChange: (value: string) => void
  onAccountNumberChange: (value: string) => void
  onPaymentAmountChange: (value: string) => void
}) {
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <label className="text-sm font-medium" htmlFor={`${idPrefix}-vendor`}>Vendor</label>
        <Select value={vendorId} onValueChange={onVendorChange} disabled={disabled || vendorDisabled}>
          <SelectTrigger id={`${idPrefix}-vendor`} aria-label="Vendor">
            <SelectValue placeholder="Select a vendor" />
          </SelectTrigger>
          <SelectContent>
            {vendors.map((vendor) => (
              <SelectItem key={vendor.id} value={String(vendor.id)}>
                {String(vendor.id).padStart(3, "0")} — {vendor.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
        <div className="min-w-0 space-y-1.5">
          <label className="text-sm font-medium" htmlFor={`${idPrefix}-account`}>Account Number</label>
          <Input
            id={`${idPrefix}-account`}
            aria-label="Account Number"
            maxLength={50}
            value={accountNumber}
            disabled={disabled}
            onChange={(event) => onAccountNumberChange(event.target.value)}
          />
        </div>
        <div className="space-y-1.5">
          <label className="text-sm font-medium" htmlFor={`${idPrefix}-amount`}>Payment Amount</label>
          <Input
            id={`${idPrefix}-amount`}
            aria-label="Payment Amount"
            type="text"
            inputMode="decimal"
            value={paymentAmount}
            disabled={disabled}
            onChange={(event) => onPaymentAmountChange(event.target.value)}
          />
        </div>
      </div>
    </div>
  )
}
